// Areas we serve JS
document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll(".ib-loc-namearrow");

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", function () {
      const dropdown = this.nextElementSibling;

      // Close all other dropdowns
      document.querySelectorAll(".ib-dropdown-menu").forEach((menu) => {
        if (menu !== dropdown) {
          slideUp(menu);
          menu.previousElementSibling.classList.remove("ib-color-locname");
        }
      });

      // Toggle this dropdown
      if (dropdown.style.display === "block") {
        slideUp(dropdown);
        this.classList.remove("ib-color-locname");
      } else {
        slideDown(dropdown);
        this.classList.add("ib-color-locname");
      }
    });
  });

  // Smooth slide-down effect
  function slideDown(element) {
    element.style.display = "block";
    element.style.overflow = "hidden";
    element.style.height = "0px";

    const height = element.scrollHeight + "px";

    setTimeout(() => {
      element.style.height = height;
    }, 10);

    setTimeout(() => {
      element.style.height = "auto";
      element.style.overflow = "visible";
    }, 300);
  }

  // Smooth slide-up effect
  function slideUp(element) {
    element.style.height = element.scrollHeight + "px";
    element.style.overflow = "hidden";

    setTimeout(() => {
      element.style.height = "0px";
    }, 10);

    setTimeout(() => {
      element.style.display = "none";
      element.style.height = "auto";
    }, 300);
  }
});


// View More / View Less Logic
document.addEventListener("DOMContentLoaded", function () {
  const locations = document.querySelectorAll(".ib-location-container");

  // Hide everything after 18 items
  locations.forEach((location, index) => {
    if (index >= 18) {
      location.style.display = "none";
    }
  });

  // Create buttons
  const viewAllButton = document.createElement("div");
  viewAllButton.className = "ib-viewall-cont ib-view-all";
  viewAllButton.textContent = "View All Locations";

  const viewLessButton = document.createElement("div");
  viewLessButton.className = "ib-viewless-cont ib-view-all";
  viewLessButton.textContent = "View Less";
  viewLessButton.style.display = "none";

  const areasFlex = document.querySelector(".ib-areas-flex");
  if (areasFlex) {
    areasFlex.insertAdjacentElement("afterend", viewAllButton);
    areasFlex.insertAdjacentElement("afterend", viewLessButton);
  }

  // Show all
  viewAllButton.addEventListener("click", function () {
    locations.forEach((location) => {
      location.style.display = "block";
    });
    viewAllButton.style.display = "none";
    viewLessButton.style.display = "block";
  });

  // Show less
  viewLessButton.addEventListener("click", function () {
    locations.forEach((location, index) => {
      if (index >= 18) {
        location.style.display = "none";
      }
    });
    viewLessButton.style.display = "none";
    viewAllButton.style.display = "block";
  });
});